// 正在加载问卷目录
export const LOADING_QUESTIONNAIRE_CONTENTS = "loadingQuestionnaireContents";
// 正在加载问题
export const LOADING_QUESTIONNAIRE = "loadingQuestionnaire";
